
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/hooks/useAuth';
import { Toaster } from '@/components/ui/toaster';
import SecureAuthGuard from '@/components/SecureAuthGuard';
import Layout from '@/components/Layout';
import Index from '@/pages/Index';
import Dashboard from '@/pages/Dashboard';
import RoleHub from '@/pages/RoleHub';
import RoleDetailPage from '@/pages/RoleDetailPage';
import ReferralViewPage from '@/pages/ReferralViewPage';
import MyProfile from '@/pages/MyProfile';
import HRDashboardPage from '@/pages/HRDashboardPage';
import ManageRolesPage from '@/pages/ManageRolesPage';
import BillingPage from '@/pages/BillingPage';
import PaymentsPage from '@/pages/PaymentsPage';
import SecurityAuditPage from '@/pages/SecurityAuditPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import NotFound from '@/pages/NotFound';
import PublicRolePage from '@/components/PublicRolePage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/r/:slug" element={<PublicRolePage />} />
            <Route path="/" element={
              <SecureAuthGuard>
                <Layout>
                  <Navigate to="/dashboard" replace />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/dashboard" element={
              <SecureAuthGuard>
                <Layout>
                  <Dashboard />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/role-hub" element={
              <SecureAuthGuard>
                <Layout>
                  <RoleHub />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/roles/:roleId" element={
              <SecureAuthGuard>
                <Layout>
                  <RoleDetailPage />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/referrals/:roleId" element={
              <SecureAuthGuard>
                <Layout>
                  <ReferralViewPage />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/my-profile" element={
              <SecureAuthGuard>
                <Layout>
                  <MyProfile />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/hr" element={
              <SecureAuthGuard>
                <Layout>
                  <HRDashboardPage />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/manage-roles" element={
              <SecureAuthGuard>
                <Layout>
                  <ManageRolesPage />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/billing" element={
              <SecureAuthGuard>
                <Layout>
                  <BillingPage />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/payments" element={
              <SecureAuthGuard>
                <Layout>
                  <PaymentsPage />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="/security-audit" element={
              <SecureAuthGuard>
                <Layout>
                  <SecurityAuditPage />
                </Layout>
              </SecureAuthGuard>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
